/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutPatientStatusRequestBodyTypename = "PutPatientStatusRequestBody" as const;

/**
 *
 * @export
 * @interface PutPatientStatusRequestBody
 */
export interface PutPatientStatusRequestBody {
  /**
   *
   * @type {string}
   * @memberof PutPatientStatusRequestBody
   */
  status: PutPatientStatusRequestBodyStatusEnum;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutPatientStatusRequestBody
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PutPatientStatusRequestBodyStatusEnum {
  Verified = "verified",
}

export function PutPatientStatusRequestBodyFromJSON(json: any): PutPatientStatusRequestBody {
  return PutPatientStatusRequestBodyFromJSONTyped(json, false);
}

export function PutPatientStatusRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutPatientStatusRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutPatientStatusRequestBodyTypename,

    status: json["status"],
  };
}

export function PutPatientStatusRequestBodyToJSON(object?: PutPatientStatusRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    status: value.status,
  };
}
